<template>
  <div class="refinement" :class="containerClasses">
    <div
      class="refinement-header expander"
      role="button"
      tabindex="0"
      :aria-label="`${title} ${isExpanded ? 'Expanded' : 'Collapsed'}`"
      :aria-expanded="isExpanded"
      :aria-controls="groupingId"
      @click="expandToggle"
      @keyup.enter="expandToggle"
    >
      <h2 class="title">
        <i class="material-symbols-outlined fill" aria-hidden="true" :data-icon="icon"></i>
        <span>{{ title }}</span>
        <span v-show="hasFilters" class="active-filters" aria-label="Has Active Filters"></span>
      </h2>
      <div class="expand-collapse">
        <i
          class="material-symbols-outlined fill"
          aria-hidden="true"
          :data-icon="isExpanded ? 'expand_less' : 'expand_more'"
        ></i>
      </div>
    </div>
    <div :id="groupingId" :aria-hidden="!isExpanded" class="refinement-grouping">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Handles expand and collapse of filter groups
 */

import { computed } from 'vue'
import { useSearchStore } from '@/stores/search'
import { cachePut } from '@/utils/local-storage-cache'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    cacheKey?: string
    groupingId: string
    title: string
    hasFilters?: boolean
    containerClasses?: string
    icon?: string
  }>(),
  {
    cacheKey: '',
    hasFilters: false,
    containerClasses: '',
    icon: 'tune',
  },
)

/** STATE **/
const searchStore = useSearchStore()

/** EMITS **/
// n/a

/** COMPUTED **/
const isExpanded = computed(() => searchStore.filterGroupingsExpanded[props.groupingId])

/** METHODS **/
function expandToggle() {
  // update pinia first
  const payload = { groupingId: props.groupingId, isExpanded: !isExpanded.value }
  searchStore.updateFilterGroupingsExpanded(payload)

  // then save to local storage by replacing entire cache obj
  if (props.cacheKey) {
    cachePut({
      key: props.cacheKey,
      value: { ...searchStore.filterGroupingsExpanded },
    })
  }
}
</script>
